export const facilityAppDownloadBannerVisibilityLocalStorageKey =
  "facilityAppDownloadBannerVisible";
export const facilityAppStoreUrl = "https://workplace.clipboardworks.com/app";
